import React from 'react';

import { Link } from 'ui/components/Link';

type Props = {
  toggleMenu: () => void;
};

export const BlogNavBar = ({ toggleMenu }: Props) => {
  return (
    <nav className="font-formula  relative z-10 box-border flex w-[100vw] items-center justify-between border-y border-black bg-white px-4 py-2 uppercase">
      <Link to={'/'} hasDecoration={false}>
        <p className="-mb-1 cursor-pointer text-2xl text-black md:text-3xl">
          shop
        </p>
      </Link>
      <p
        onClick={toggleMenu}
        className="-mb-1 cursor-pointer text-2xl text-black md:text-3xl"
      >
        menu
      </p>
    </nav>
  );
};
